import { Typography } from '@automata/ui';
import { Box, Stack, styled, useTheme } from '@mui/system';
import { CSSProperties } from 'react';
import { Position } from 'reactflow';

import Handle from './Handle';

type Props = {
  color?: string;
  id: string;
  name: string;
  position: Position;
  handleStyle?: CSSProperties | undefined;
  isConnected: boolean;
};

// TODO(AL, 14/10/2024): Lets get rid of these magic numbers
export const DataHandle = styled(Handle, {
  shouldForwardProp: (prop) => prop !== 'isConnected',
})<{ isConnected?: boolean }>`
  transform: translate(-50%, 0) rotate(45deg);
  transform-origin: center center;
  border-radius: 2px;
  width: 16px;
  height: 16px;

  border-color: ${({ theme }) => theme.palette.neutral[900]};
  background: ${(p) =>
    p.isConnected
      ? p.theme.palette.neutral[900]
      : p.theme.palette.common.white};

  ${({ position }) => {
    switch (position) {
      case Position.Top:
        return 'top: -8px;';
      case Position.Bottom:
        return 'bottom: -4px;';
      case Position.Left:
        return 'left: 0px;';
      case Position.Right:
        return 'right: 0px;';
      default:
        return '';
    }
  }};
`;

export const DataHandleWithLabel = ({
  color = 'black',
  id,
  name,
  position,
  handleStyle,
  isConnected,
}: Props) => {
  const theme = useTheme();

  return (
    <Box
      position="relative"
      sx={{
        whiteSpace: 'nowrap',
        textAlign: 'center',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack>
        <Box
          sx={{
            backgroundColor: isConnected
              ? theme.palette.neutral[200]
              : 'inherit',
            border:
              color === 'black'
                ? `2px solid ${theme.palette.neutral[200]}`
                : 'none',
            borderRadius: 2,
          }}
        >
          <Typography
            color={color}
            variant="h6"
            textAlign="center"
            paddingY={0.5}
            paddingX={1}
            noWrap
          >
            {name}
          </Typography>
        </Box>
      </Stack>
      <DataHandle
        id={id}
        type="source"
        position={position}
        style={handleStyle}
        isConnected={isConnected}
      />
    </Box>
  );
};
